import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Section } from './ui/Section';
import { Kicker, H2 } from './ui/Typography';
import { useT } from '../i18n/LanguageContext';
export function FAQSection() {
  const t = useT().faq;
  return <Section hasOrb={false} data-id="element-44">
      <div className="max-w-3xl mx-auto" data-id="element-45">
        <div className="text-center mb-16" data-id="element-46">
          <div className="flex justify-center" data-id="element-47">
            <Kicker data-id="element-48">{t.kicker}</Kicker>
          </div>
          <H2 data-id="element-49">{t.title}</H2>
        </div>

        <div className="space-y-4" data-id="element-50">
          {t.items.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} delay={i * 0.05} data-id="element-51" />)}
        </div>
      </div>
    </Section>;
}
function FAQItem({
  question,
  answer,
  delay
}: {
  question: string;
  answer: string;
  delay: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.01
  }} transition={{
    duration: 0.4,
    delay
  }} className="border-[2px] border-border rounded-[10px] overflow-hidden bg-[rgba(255,255,255,0.02)]" data-id="element-52">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-53">
        <span className="font-archivo text-lg uppercase tracking-tight pr-8" data-id="element-54">
          {question}
        </span>
        <span className="text-brand font-mono text-xl shrink-0" data-id="element-55">
          {isOpen ? '−' : '+'}
        </span>
      </button>

      <AnimatePresence data-id="element-56">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2
      }} data-id="element-57">
            <div className="px-6 pb-6 text-ink-dim border-t border-border mt-2 pt-4" data-id="element-58">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}